import { Link, useNavigate } from "react-router-dom";
import Logo from "../../components/common/Logo";

const MailCheckIcon = () => (
  <svg
    className="h-8 w-8 text-[#FF6A3D]"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.5 12.5l1.75 1.75L21 10.5"
    />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
    />
  </svg>
);

export const UserAccountRegistered = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12"
      style={{ background: "linear-gradient(180deg, #F7F8FA 0%, #EEF1F4 100%)" }}
    >
      <div
        onClick={() => navigate("/")}
        className="flex items-center justify-center gap-x-2 cursor-pointer mb-8"
      >
        <Logo />
        <h1 className="text-2xl font-semibold text-[#111827]">EatsBits</h1>
      </div>

      <div className="w-full max-w-[460px] rounded-[14px] bg-white p-8 text-center shadow-[0_12px_30px_rgba(0,0,0,0.08)]">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#FFF0EB]">
          <MailCheckIcon />
        </div>

        <h2
          className="mt-6 text-[28px] font-bold leading-tight text-[#111827]"
          style={{ letterSpacing: "-0.01em" }}
        >
          Check your email
        </h2>
        <p className="mt-3 text-[15px] leading-6 text-[#6B7280]">
          We sent an activation link to the registered email address. Open that
          link to activate your EatsBits account.
        </p>

        <Link
          to="/login"
          className="mt-8 inline-flex h-12 w-full items-center justify-center gap-2 rounded-[10px] bg-[#FF6A3D] text-[15px] font-semibold text-white transition-all duration-150 hover:-translate-y-px hover:bg-[#E85C32] active:translate-y-0"
        >
          <ArrowLeftIcon />
          Back to login
        </Link>
      </div>
    </div>
  );
};
